import { render, staticRenderFns } from "./UserItemEdit.vue?vue&type=template&id=2048e0d9"
import script from "./UserItemEdit.vue?vue&type=script&lang=js"
export * from "./UserItemEdit.vue?vue&type=script&lang=js"
import style0 from "./UserItemEdit.vue?vue&type=style&index=0&id=2048e0d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports